import { isMobile } from 'react-device-detect';
import { State } from 'app/types/cart';

export const INITIAL_STATE: State = {
  cart: [],
  totalItems: 0,
  totalPrice: 0,
  priceDiscount: 0,
  percentageDiscount: 0,
  manualPrice: 0,
  highlightedProduct: null,
  professionals: [],
  voucher: null,
  modified: true,
};
export const SHOW_TOP_BAR = false;

export const HEADER_HEIGHT_MOBILE = SHOW_TOP_BAR ? 56 + 51 + 20 : 56 + 51;
export const HEADER_HEIGHT_DESKTOP = SHOW_TOP_BAR ? 72 + 51 + 20 : 72 + 51;

export const DERMA_HEADER_HEIGHT_MOBILE = 68;
export const DERMA_HEADER_HEIGHT_DESKTOP = 80;

export function headerHeight() {
  return isMobile ? HEADER_HEIGHT_MOBILE : HEADER_HEIGHT_DESKTOP;
}

export function getDefaultLdJson(
  title: string,
  description: string,
  url: string
) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: title,
    description: description,
    url: url,
    inLanguage: 'es-ES',
    copyrightHolder: {
      '@type': 'Organization',
      '@id': 'https://www.holaglow.com',
    },
    publisher: {
      '@type': 'Organization',
      '@id': 'https://www.holaglow.com/#organization',
      name: 'Holaglow',
      url: 'https://www.holaglow.com',
      description:
        'Holaglow es una red de clínicas de medicina estética que ofrece tratamientos personalizados para realzar la belleza natural.',
      knowsAbout: [
        'Medicina estética',
        'Tratamientos faciales',
        'Bienestar',
        'Rejuvenecimiento facial',
        'Salud estética',
      ],
      sameAs: [
        'https://www.facebook.com/p/Holaglow-100089635050832/',
        'https://www.instagram.com/holaglow.clinics/',
        'https://www.youtube.com/channel/UClbkeOPUeqXaYyAnrHSencA',
        'https://es.linkedin.com/company/holaglow',
      ],
      email: 'hola@holaglow.com',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'technical and billing support',
        telephone: '+34 682 417 208',
        email: 'hola@holaglow.com',
        availableLanguage: ['es', 'en', 'ca'],
        hoursAvailable: [
          {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
            opens: '10:00',
            closes: '19:00',
          },
        ],
      },
      brand: {
        '@type': 'Organization',
        name: 'Holaglow',
        logo: {
          '@type': 'ImageObject',
          url: 'https://www.holaglow.com/images/holaglowLogo.png',
        },
      },
    },
    author: {
      '@type': 'Organization',
      name: 'Equipo médico Holaglow',
      url: 'https://www.holaglow.com/quienes-somos',
      description:
        'Equipo especializado en tratamientos estéticos médicos y personalizados.',
      knowsAbout: 'Medicina estética, tratamientos no invasivos',
      sameAs: ['https://www.holaglow.com/quienes-somos'],
    },
  };
}

export function getLdJson(item: any) {
  return {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: [
      {
        '@type': 'SiteNavigationElement',
        position: 1,
        name: 'Tratamientos de medicina estética en Holaglow',
        url: 'https://www.holaglow.com/tratamientos',
      },
      {
        '@type': 'SiteNavigationElement',
        position: 2,
        name: 'Tratamientos de estética avanzada - Holaglow',
        url: 'https://www.holaglow.com/estetica-avanzada',
      },
      {
        '@type': 'SiteNavigationElement',
        position: 3,
        name: 'Tratamientos de longevidad - Holaglow',
        url: 'https://www.holaglow.com/longevidad',
      },
      {
        '@type': 'SiteNavigationElement',
        position: 4,
        name: 'Clínicas de Medicina Estética',
        url: 'https://www.holaglow.com/clinicas',
      },
      item,
    ],
  };
}
